<template>

    <div>
       
        <FormComponent @submit="submit" title="直接买断" :data="data" canEdit="true"></FormComponent>
    </div>
    </template>
    
    <script setup>
    import FormComponent from '@/components/FormComponent.vue';
    import {useAddBillingRule2} from "@/use/billingRule"
    
    const {data,submit}=useAddBillingRule2();
    </script>